module.exports = __webpack_public_path__ + "static/visie-3-e1af3b78a50facd2347f16384ae04911.jpg";